// What the Coach Assistants list shows in its "Assigned to" column. Same
// precedence as the assignment dropdown in AssistantModal: default, then
// trial, then a specific coach, else unassigned.

const coachName = (coach) => {
  const first = [coach.first_name, coach.last_name].filter(Boolean).join(' ').trim();
  return first || coach.full_name || coach.email || 'Unnamed coach';
};

export const assignmentLabel = (assistant, coachesById) => {
  if (assistant.is_default) return { kind: 'default', text: 'Default for all' };
  if (assistant.is_trial) return { kind: 'trial', text: 'Trial' };
  if (assistant.coach_id) {
    // Coach list still loading: don't flash "Unknown coach".
    if (!coachesById) return { kind: 'coach', text: 'Coach…' };
    const coach = coachesById.get(assistant.coach_id);
    // A removed coach, or a profile whose role changed, would otherwise
    // look unassigned.
    if (!coach) return { kind: 'unknown', text: `Unknown coach (${assistant.coach_id.slice(0, 8)})` };
    return { kind: 'coach', text: `Coach: ${coachName(coach)}` };
  }
  return { kind: 'none', text: 'Unassigned' };
};

export const ASSIGNMENT_BADGE_CLASSES = {
  default: 'bg-indigo-100 text-indigo-800',
  trial: 'bg-yellow-100 text-yellow-800',
  coach: 'bg-green-50 text-green-800',
  unknown: 'bg-red-100 text-red-800',
  none: 'bg-gray-100 text-gray-600',
};
